import Spinner from 'src/app/components/Elements/Spinner';

export const Loading = () => {
  return (
    <div>
      <div>
        <Spinner />
      </div>
    </div>
  );
};
